import * as React from 'react';
import { FiniteScrollBrowserURLManager } from './FiniteScrollBrowserURLManager';
import { FiniteScrollNextArticles } from './FiniteScrollNextArticles';
import { ArticleComponentDataProps } from '../../templates/utils/articleComponent.utils';
import { FiniteScrollArticleData } from '../../store/template/postPage/utils/createFiniteScrollArticleData';

interface FiniteScrollProps {
  articleComponent: React.FunctionComponent<ArticleComponentDataProps>;
  articles: Array<FiniteScrollArticleData> | null;
  by: string;
  siteName: string;
  templateName: string;
  revcontentWidgetID: string;
  openWebId: string | null;
}

interface ConfigDataForFiniteScrollArticle {
  by: string;
  siteName: string;
  templateName: string;
  revcontentWidgetID: string;
  openWebId: string | null;
}

const createFullArticleComponentDataPropsForFiniteScrollArticles = (finiteScrollArticles: Array<FiniteScrollArticleData>, configData: ConfigDataForFiniteScrollArticle) => {
  return finiteScrollArticles.map(finiteScrollArticle => ({
    ...finiteScrollArticle,
    sideBar1Id: null,
    sideBar2Id: null,
    by: configData.by,
    siteName: configData.siteName,
    templateName: configData.templateName,
    revcontentWidgetID: configData.revcontentWidgetID,
    openWebId: configData.openWebId,
  }));
};


export const FiniteScroll: React.FunctionComponent<FiniteScrollProps> = props => {
  const { children, articles, articleComponent, openWebId, by, revcontentWidgetID, siteName, templateName } = props;
  if (!articles || articles.length === 0) {
    return (
      <React.Fragment>
        {children}
      </React.Fragment>
    );
  }
  const articlesData = createFullArticleComponentDataPropsForFiniteScrollArticles(articles, {
    by,
    siteName,
    templateName,
    revcontentWidgetID,
    openWebId,
  });

  return (
    <FiniteScrollBrowserURLManager>
      {children}
      <FiniteScrollNextArticles articles={articlesData} articleComponent={articleComponent} />
    </FiniteScrollBrowserURLManager>
  );
};
